import React from 'react';

interface ChampionStatsProps {
  matches: any[];
  puuid: string;
  ddragonVersion: string;
}

interface ChampStat {
  championName: string;
  games: number;
  wins: number;
  kills: number;
  deaths: number;
  assists: number;
  cs: number;
  totalDuration: number;
}

const ChampionStats: React.FC<ChampionStatsProps> = ({ matches, puuid, ddragonVersion }) => {
  const statsMap = new Map<string, ChampStat>();

  for (const match of matches) {
    const p = match.info?.participants?.find((pp: any) => pp.puuid === puuid);
    if (!p) continue;

    const existing = statsMap.get(p.championName);
    if (existing) {
      existing.games++;
      existing.wins += p.win ? 1 : 0;
      existing.kills += p.kills;
      existing.deaths += p.deaths;
      existing.assists += p.assists;
      existing.cs += p.totalMinionsKilled + p.neutralMinionsKilled;
      existing.totalDuration += match.info.gameDuration;
    } else {
      statsMap.set(p.championName, {
        championName: p.championName,
        games: 1,
        wins: p.win ? 1 : 0,
        kills: p.kills,
        deaths: p.deaths,
        assists: p.assists,
        cs: p.totalMinionsKilled + p.neutralMinionsKilled,
        totalDuration: match.info.gameDuration,
      });
    }
  }

  const sorted = Array.from(statsMap.values()).sort((a, b) => b.games - a.games);

  if (sorted.length === 0) return null;

  return (
    <div className="champ-stats-card">
      <h3 className="ranked-label">Champion Stats</h3>
      <div className="champ-stats-list">
        {sorted.map((s) => {
          const winRate = Math.round((s.wins / s.games) * 100);
          const avgKills = (s.kills / s.games).toFixed(1);
          const avgDeaths = (s.deaths / s.games).toFixed(1);
          const avgAssists = (s.assists / s.games).toFixed(1);
          const avgCs = Math.round(s.cs / s.games);
          const csPerMin = (s.cs / (s.totalDuration / 60)).toFixed(1);
          const kda = s.deaths === 0 ? 'Perfect' : ((s.kills + s.assists) / s.deaths).toFixed(2);

          return (
            <div key={s.championName} className="champ-stat-row">
              <img
                src={`https://ddragon.leagueoflegends.com/cdn/${ddragonVersion}/img/champion/${s.championName}.png`}
                alt={s.championName}
                className="champ-stat-icon"
              />
              <div className="champ-stat-info">
                <span className="champ-stat-name">{s.championName}</span>
                <span className="champ-stat-cs">CS {avgCs} ({csPerMin})</span>
              </div>
              <div className="champ-stat-kda">
                <span className="champ-kda-avg">{avgKills}/{avgDeaths}/{avgAssists}</span>
                <span className="champ-kda-value">{kda === 'Perfect' ? 'Perfect' : `${kda} KDA`}</span>
              </div>
              <div className="champ-stat-wr">
                <span className={`champ-wr-value ${winRate >= 50 ? 'wr-positive' : 'wr-negative'}`}>
                  {winRate}%
                </span>
                <span className="champ-stat-record">{s.games} games</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChampionStats;
